import { render, staticRenderFns } from "./TEST_HXTKT.vue?vue&type=template&id=4449d78a&scoped=true"
import script from "./TEST_HXTKT.vue?vue&type=script&lang=js"
export * from "./TEST_HXTKT.vue?vue&type=script&lang=js"
import style0 from "./TEST_HXTKT.vue?vue&type=style&index=0&id=4449d78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4449d78a",
  null
  
)

export default component.exports